<template>
  <div id="app">
    <!-- <img @click.prevent src="./assets/logo.png"> -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive" v-bind:onRef="onRef"  :getRef="getRef" />
    </keep-alive>
    
    <router-view v-if="!$route.meta.keepAlive" v-bind:onRef="onRef"  :getRef="getRef" >
    <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
    </router-view>
    <dialog-bar 
          :showMask="showMask"
          type="danger"
          :content="contentMessage"
          dangerText="我知道了"/>
  </div>
</template>

<script>
  import '@/assets/css/common.less';
  import dialogBar from "@/components/tabBar/smallDialog";
  import { mapState } from "vuex"; 
export default {
  name: 'App',
  components: {
    dialogBar
  },
  computed: mapState({
    showMask: state => state.checkAgentInfo.showMask, 
    contentMessage: state => state.checkAgentInfo.contentMessage, 
  }),
  methods:{
      getRef(){
        return this;
      },
      onRef(childKey,ref){

          this[childKey]=ref;

      },
  }
}
</script>

<style>


#app {
  font-family: HelveticaNeue,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center; 
  width:100%;
  height:100%;
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/App.vue